import "./App.css";
import Pokedex from "./pages/Pokedex";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProfileCard from "./components/ProfileCard";
import { useEffect, useState } from "react";
import NotFound from "./components/NotFound";
import ScrollToTop from "./utils/ScrollToTop";

function App() {
  const [titleTab, setTitleTab] = useState("Pokedex | pandasneezing");

  useEffect(() => {
    document.title = titleTab;
  }, [titleTab]);
  return (
    <Router>
      <Navbar setTitle={setTitleTab} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home setTitle={setTitleTab} />} />
        <Route path="/about" element={<About />} />
        <Route path="/pokedex" element={<Pokedex />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ejemplo" element={<ProfileCard />} />
        {/* Ruta 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
